import { signIn } from '../../service/util/oauth/oauth'
import { showDialog, hideDialog } from '../../state/actions/ui/ui'
import { Sizes as ModalSizes } from '../../stories/atoms/Modal/Modal'
import { getConfig } from '../../service/util/config/config'
import { Dispatch } from 'react'
import { AnyAction } from 'redux'
import { Action, Category } from '../analytics-data-attributes/analyticsAttributes'

export const unexpectedResponse = () => showDialog({
  title: 'Er ging iets mis',
  content: 'Onverwachte serverreactie ontvangen.',
})

export const unexpectedError = () => showDialog({
  title: 'Er ging iets mis',
  content: 'Probeer het opnieuw of vernieuw de pagina',
})

export const unauthorizedError = (dispatch: Dispatch<AnyAction>) => showDialog({
  title: 'Om deze functie te gebruiken moet je inloggen',
  content: 'Voor een aantal functies van ons platform moet je eerst inloggen. Je kunt dan producten toevoegen aan je winkelwagen of jouw vacatures bekijken',
  size: ModalSizes.medium,
  primaryAction: {
    label: 'Inloggen',
    onClick: signIn,
  },
  secondaryAction: {
    label: 'Annuleren',
    onClick: () => dispatch(hideDialog()),
  },
})

export const unauthorizedWebshopError = (productTitle: string) => showDialog({
  title: 'Account nodig om verder te gaan',
  content: 'Om producten te kunnen toevoegen aan je mandje dien je eerst in te loggen of een account aan te maken',
  size: ModalSizes.small,
  primaryAction: {
    label: 'Account aanmaken',
    onClick: () => global.window.location.assign(getConfig().SALES_FORCE_REGISTER_URL),
    dataAnalyticsAction: Action.addToCartModalClickToRegister,
    dataAnalyticsLabel: productTitle,
    dataAnalyticsCategory: Category.ecommerce,
  },
  secondaryAction: {
    label: 'Inloggen',
    onClick: () => {
      const state = btoa(window.location.href) 
      window.location.href = `${process?.env?.NEXT_PUBLIC_LOGIN_URL}?state=${state}`
    },
    dataAnalyticsAction: Action.addToCartModalClickToLogin,
    dataAnalyticsLabel: productTitle,
    dataAnalyticsCategory: Category.ecommerce,
  }
})
